import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
import { RawFloorplanCaptureSchema } from '../entities/rawFloorplan.js';
export const CreateRawFloorplanBodySchema = RawFloorplanCaptureSchema.pick({
    captureId: true,
    rawOutput: true,
});
export const CreateRawFloorplanHeadersSchema = ApiLambdalerAuthHeaderWithRequestActorSchema;
export const CreateRawFloorplanPathSchema = z.object({
    entityId: InspectionEntityCornSchema,
    inspectionId: InspectionCornSchema,
});
export const CreateRawFloorplanResponseSchema = RawFloorplanCaptureSchema;
export const CreateRawFloorplanApiSchema = {
    body: CreateRawFloorplanBodySchema,
    params: CreateRawFloorplanPathSchema,
    headers: CreateRawFloorplanHeadersSchema,
    response: CreateRawFloorplanResponseSchema,
};
export const CreateRawFloorplanRequestSchema = CreateRawFloorplanBodySchema.merge(CreateRawFloorplanHeadersSchema).merge(CreateRawFloorplanPathSchema);
